import {NgModule} from "@angular/core";

import { LocalTimePipe } from './local-time.pipe';
import {SecurePipe} from "./secure-pipe.pipe";
import {UrlHelperService} from "../services/url-helper.service";
import {MinusSignToParens} from './minus-sign-to-parens.pipe';

@NgModule({
    declarations: [LocalTimePipe, SecurePipe, MinusSignToParens],
    exports: [LocalTimePipe, SecurePipe, MinusSignToParens],
    providers: [
        UrlHelperService,
    ]
})

export class PipesModule {}



// WEBPACK FOOTER //
// ./src/app/pipes/pipes.module.ts